import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import ModalHistorialWhatsapp from './ModalHistorialWhatsapp';

const BotonWhatsapp = ({
  numeroTelefono,
  nombreCliente,
  fechaTurno,
  horaTurno,
  horaTurnoAnses,
  tipoEvento,
  lugar,
  textoBoton,
  className,
  disabled,
  contactosAdicionales,
  tramiteId,
}) => {
  const [modalAbierto, setModalAbierto] = useState(false);
  const [loading] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    if (disabled || loading || !numeroTelefono) return;
    setModalAbierto(true);
  };

  if (!numeroTelefono && !disabled) return null;

  const claseBoton = !className.includes('btn-') ? `btn-success ${className}` : className;
  const textoMostrar = textoBoton || 'Enviar Recordatorio';

  return (
    <>
      <button
        className={`btn rounded-pill d-inline-flex align-items-center ${claseBoton}`}
        style={{ backgroundColor: '#25D366', borderColor: '#25D366', color: 'white' }}
        onClick={handleClick}
        title={!numeroTelefono ? 'Sin teléfono registrado' : 'Enviar recordatorio por WhatsApp'}
        disabled={disabled || !numeroTelefono}
      >
        {loading
          ? <CircularProgress size={20} style={{ color: 'white', marginRight: '8px' }} />
          : <i className="bi bi-whatsapp me-2" style={{ fontSize: '1.2rem' }} />}
        {textoMostrar}
      </button>

      <ModalHistorialWhatsapp
        open={modalAbierto}
        onClose={() => setModalAbierto(false)}
        tramiteId={tramiteId}
        numeroTelefono={numeroTelefono}
        nombreCliente={nombreCliente}
        fechaTurno={fechaTurno}
        horaTurno={horaTurno}
        horaTurnoAnses={horaTurnoAnses}
        tipoEvento={tipoEvento}
        lugar={lugar}
        contactosAdicionales={contactosAdicionales}
      />
    </>
  );
};

BotonWhatsapp.propTypes = {
  numeroTelefono:       PropTypes.string,
  nombreCliente:        PropTypes.string,
  fechaTurno:           PropTypes.string,
  horaTurno:            PropTypes.string,
  horaTurnoAnses:       PropTypes.string,
  tipoEvento:           PropTypes.string,
  lugar:                PropTypes.string,
  textoBoton:           PropTypes.string,
  className:            PropTypes.string,
  disabled:             PropTypes.bool,
  tramiteId:            PropTypes.number,
  contactosAdicionales: PropTypes.arrayOf(PropTypes.shape({
    nombre:      PropTypes.string.isRequired,
    nroTelefono: PropTypes.string.isRequired,
    relacion:    PropTypes.string
  }))
};

BotonWhatsapp.defaultProps = {
  numeroTelefono:       '',
  nombreCliente:        '',
  fechaTurno:           '',
  horaTurno:            '',
  horaTurnoAnses:       '',
  tipoEvento:           '',
  lugar:                '',
  textoBoton:           '',
  className:            '',
  disabled:             false,
  tramiteId:            null,
  contactosAdicionales: []
};

export default BotonWhatsapp;
